//wxchunyang.cn春阳地址
// const picUrl = "http://apierp.wxchunyang.cn/cps/"; // 图片反显
// const BrowseUrl = "http://file.wxchunyang.cn/"; //  obs上传文件
// const richUrl = "http://mallapi.wxchunyang.cn/file"; // 富文本上传文件
// const baseUrl = "http://mallapi.wxchunyang.cn"; // 公共地址
// const sfUrl = "http://sfapi.jsdny.cn"; // 顺丰api地址
//yy12365.com印友地址
// const picUrl = "http://erp.smartprint.cn/cps/"; // 图片反显
// const BrowseUrl = "https://obs.smartprint.cn/"; //  obs上传文件
// const richUrl = "http://portalapi.smartprint.cn/file"; // 富文本上传文件
// const baseUrl = "http://portalapi.smartprint.cn"; // 公共地址
// const sfUrl = "http://sfapi.yyszhyyjy.com"; // 顺丰api地址
//
// const picUrl = "http://test.jsdny.cn/cps/"; // 图片反显
// const BrowseUrl = "https://obs.jsdny.cn/"; //  obs上传文件
// const richUrl = "http://api.jsdny.cn/file"; // 富文本上传文件
// const baseUrl = "http://api.jsdny.cn"; // 公共地址
// const sfUrl = "http://sfapi.jsdny.cn"; // 顺丰api地址

const picUrl = "http://file.douhaoyin.com/cps/"; // 图片反显
const BrowseUrl = "http://file.douhaoyin.com/"; //  obs上传文件
const richUrl = "http://api.douhaoyin.com/file"; // 富文本上传文件
//const baseUrl = "http://127.0.0.1:8098"; // 公共地址
const baseUrl = "http://api.douhaoyin.com"; // 公共地址
const sfUrl = "http://sfapi.douhaoyin.com"; // 顺丰api地址
export default {
  picUrl,
  BrowseUrl,
  richUrl,
  baseUrl,
  sfUrl
};
